(function () {
  function initMenu() {
    var menu = document.querySelector('.onesck-mobile-menu');
    if (!menu || menu.dataset.onesckReady) return;
    menu.dataset.onesckReady = 'true';

    var observer = new MutationObserver(function () {
      var open = menu.classList.contains('js-menu--is-open');
      document.body.classList.toggle('onesck-menu-open', open);
      document.querySelectorAll('.site-header .js-toggle-slide-nav').forEach(function (button) {
        button.setAttribute('aria-expanded', String(open));
      });
      if (!open && menu.contains(document.activeElement)) {
        var headerButton = document.querySelector('.site-header .js-toggle-slide-nav');
        if (headerButton) headerButton.focus();
      }
    });
    observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.onesck-mobile-menu__tab[data-onesck-tab]');
    if (tab) {
      var menu = tab.closest('.onesck-mobile-menu');
      menu.querySelectorAll('[data-onesck-tab]').forEach(function (button) {
        var active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-expanded', String(active));
      });
      menu.querySelectorAll('[data-onesck-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.onesckPanel !== tab.dataset.onesckTab;
      });
      menu.querySelector('.onesck-mobile-menu__scroll').scrollTop = 0;
    }

    var action = event.target.closest('.onesck-mobile-menu [data-onesck-close-menu]');
    if (action) {
      var closeButton = action.closest('.onesck-mobile-menu').querySelector('.onesck-mobile-menu__header .js-toggle-slide-nav');
      closeButton.click();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', initMenu);
  document.addEventListener('shopify:section:load', initMenu);
})();
